import React from "react";
import { Paperclip, X, Loader2 } from "lucide-react";
import { ReactComponent as GoogleDriveIcon } from "../../../static/icons/google-drive.svg";
import { Badge } from "../../ui/badge";
import { Button } from "../../ui/button";

export interface FileItem {
    name: string;
    uploading: boolean;
    source?: "google-drive";
}

interface AttachedFilesListProps {
    files?: FileItem[];
    onRemoveFile?: (index: number) => void;
}

export function AttachedFilesList({ files, onRemoveFile }: AttachedFilesListProps) {
    if (!files || files.length === 0) return null;

    const isRemovable = !!onRemoveFile;

    return (
        <div className={`my-3 flex flex-wrap gap-2 ${isRemovable ? "justify-start" : "justify-end"}`}>
            {files.map((file, index) => (
                <Badge
                    key={`${file.name}-${index}`}
                    variant="outline"
                    className="group inline-flex items-center gap-2 rounded-full bg-background px-3 py-1.5 text-sm font-medium text-foreground shadow-sm transition-colors hover:bg-accent"
                >
                    {file.uploading ? (
                        <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
                    ) : file.source === "google-drive" ? (
                        <GoogleDriveIcon className="h-3.5 w-3.5" />
                    ) : (
                        <Paperclip className="h-3.5 w-3.5 text-muted-foreground" />
                    )}
                    <span className="max-w-32 truncate">{file.name}</span>
                    {isRemovable && (
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={(e) => {
                                e.stopPropagation();
                                onRemoveFile(index);
                            }}
                            className="h-4 w-4 p-0 opacity-60 transition-opacity hover:opacity-100 group-hover:opacity-80"
                        >
                            <X className="h-3 w-3" />
                        </Button>
                    )}
                </Badge>
            ))}
        </div>
    );
}
